import { environment } from "../../../../../../environments/environment";
import { SaleNoteDetail, Constants } from "../../../../../core";
import { IconsOfActions, DataTable } from "../../data-table.interface";

function getUserCompanyCode(): string {
  const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return user && user.user && user.user.entity && user.user.entity.company
    ? user.user.entity.company.code
    : '';
}

function getUserSessionEntitiesCodes(): string[] {
  const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
  const user = session ? session.user : null;
  return user && user.entities ? user.entities.map(entity => entity.code) : [];
}

const iconsOfActionsList: IconsOfActions[] = [
  {
    icon: "cancel",
    tooltip: "Anular despachos",
    hasVisibleCondition: (element: SaleNoteDetail[]): boolean => {
      const filter = element.filter(
        (item) =>
          item.canceledItems === item.totalItems ||
          item.cancellable ||
          status === "Cancelado"
      );
      return element.length === filter.length;
    },
  },
  {
    icon: "returned",
    tooltip: "Devolver Productos",
    hasVisibleCondition: (element: SaleNoteDetail[]): boolean => {
      const filter = element.filter(
        (item) =>
          (item.canceledItems === item.totalItems ||
          item.cancellable ||
          status === "Cancelado") && item.originCode.split("-")[0] === "SPSA"
      );
      return element.length === filter.length;
    },
  },
];

// Cache user data outside the function
const userCompanyCode = getUserCompanyCode();
const userSessionEntitiesCodes = getUserSessionEntitiesCodes();

export const saleNoteDetail: DataTable = {
  checkbox: true,
  filter: false,
  filterDefault: "",
  searchText: "Buscar despacho",
  iconAddText: "cancel",
  dialogHability: true,
  disabled: false,
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: SaleNoteDetail) => {
    const permissions = new Set(row.userPermissions || []);
    return (
      row.availableItems <= 0 ||
      !row.cancellable ||
      (row.status && row.status.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text) ||
      !permissions.has(Constants.ConfigUser.PERMISSIONS.ANNULMENT) ||
      (row.isSellerDrop && !permissions.has(Constants.ConfigUser.PERMISSIONS.ALLOW_SELLER_CANCELLATION)) ||
      (userCompanyCode && userCompanyCode !== row.companyCode
          ? (!userSessionEntitiesCodes.includes(row.routeDetail[row.routeDetail.length - 1]) ||
            !permissions.has(Constants.ConfigUser.PERMISSIONS.ALLOW_SELLER_CANCELLATION))
          : false
      )
    );
  },
  show: 'No hay registros para mostrar',
  columns: [
    {
      title: "N° Despacho",
      name: "dispatchNumber",
      type: "string",
      checkAll: false,
      editable: false,
      class: 'center w150 w-dt-130',
      value: (element: SaleNoteDetail) => element.dispatchNumber
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.skuCode,
    },
    {
      title: "LPN",
      name: "lpnNumber",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.lpnNumber,
    },
    {
      title: "Descripción",
      name: "description",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.description.replace("�", ""),
    },
    {
      title: "Total Uds.",
      name: "totalItems",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: SaleNoteDetail) => element.totalItems,
    },
    {
      title: "Uds. cancelados",
      name: "canceledItems",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: SaleNoteDetail) => element.canceledItems,
    },
    {
      title: "Uds. disponibles",
      name: "availableItems",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: SaleNoteDetail) => element.availableItems,
    },
    {
      title: "Origen",
      name: "origin",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.origin,
    },
    {
      title: "Destino",
      name: "destination",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.destination,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.dispatchType,
    },
    {
      title: "Fecha de entrega",
      name: "deliveryDate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center w120",
      value: (element: SaleNoteDetail) => element.deliveryDate,
    },
    // {
    //   title: "Fecha de vigencia de retiro",
    //   name: "withdrawalEffectiveDate",
    //   type: "string",
    //   editable: false,
    //   checkAll: false,
    //   class: "center",
    //   value: (element: SaleNoteDetail) => element.withdrawalEffectiveDate,
    // },
    {
      title: "Estado",
      name: "status",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: SaleNoteDetail) => element.status || "",
    },
    {
      title: "Modificar",
      name: "view",
      type: "button",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: SaleNoteDetail) => {
        return {
          icon: 'edit',
          value: 'Modificar despacho',
          style: 'recordColumn icon-table',
          disabled: (element.status === "Cancelado" ||
            element.status === "Pre-Cancelado" ||
            element.status === "Entregado al cliente") || (
            (
              element.productType !== 'ST' ||
              (element.division && element.division === Constants.Dispatch.FOOD)
            ) &&
            !(
              element.saleChannel &&
              ["AGORASHOP", "JOKR", "ECOMMERCE"].includes(element.saleChannel.toUpperCase()) && element.productType === 'ST'
            )
          )
        };
      },
    },
    {
      title: "Historial",
      name: "history",
      type: "button",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: SaleNoteDetail) => {
        return {
          data: element.tracking,
          icon: "playlist_add_check",
          tooltip: "Ver historial",
          class: " recordColumn icon-table"
          // disabled: element.tracking.length === 0,
        };
      },
    },
  ],
};
